import { signOut } from 'next-auth/react'
import { Braze } from '~/lib'

export const useAuth = () => {
  const logOut = async () => {
    await signOut({
      redirect: false,
    })
    Braze.anonymize()
  }

  return {
    logOut,
  }
}
